(function () {
  function findAssemblyVariantId(form) {
    const wrap = form.querySelector('.product__assembly[data-assembly-variant-id]');
    if (!wrap) return null;
    const v = Number(wrap.dataset.assemblyVariantId);
    return Number.isFinite(v) ? v : null;
  }

  function isAssemblyChecked(form) {
    const cb = form.querySelector('#AssemblyRequired');
    return !!(cb && cb.checked);
  }

  function getMainVariantId(form) {
    const fd = new FormData(form);
    const raw = fd.get('id');
    const id = Number(raw);
    return Number.isFinite(id) ? id : null;
  }

  function getQty(form) {
    const fd = new FormData(form);
    const q = Number(fd.get('quantity') || 1);
    return Number.isFinite(q) && q > 0 ? q : 1;
  }

  async function addItems(payload) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    });

    if (!res.ok) {
      let errText = '';
      try { errText = await res.text(); } catch (e) {}
      throw new Error(`Add failed (${res.status}): ${errText}`);
    }

    return await res.json();
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.action || !form.action.includes('/cart/add')) return;

    // Only intercept when checkbox checked
    if (!isAssemblyChecked(form)) return;

    // Prevent double-handling (rare but happens)
    if (form.dataset.assemblyHandling === '1') {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return;
    }
    form.dataset.assemblyHandling = '1';

    const mainVariantId = getMainVariantId(form);
    const assemblyVariantId = findAssemblyVariantId(form);
    const qty = getQty(form);

    if (!mainVariantId || !assemblyVariantId) {
      form.dataset.assemblyHandling = '0';
      return; // allow normal submit if IDs missing
    }

    // IMPORTANT: stop Dawn product-form handler
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const payload = {
      items: [
        {
          id: mainVariantId,
          quantity: qty,
          properties: {
            "Assembly Required": "Yes",
            "_addon_parent": String(mainVariantId)
          }
        },
        {
          id: assemblyVariantId,
          quantity: qty,
          properties: {
            "_addon_for": String(mainVariantId),
            "_addon_type": "assembly"
          }
        }
      ]
    };

    try {
      await addItems(payload);

      // redirect (simple + reliable)
      window.location.href = '/cart';
    } catch (err) {
      console.error('Assembly addon error:', err);

      // If it fails, allow normal submit next time
      form.dataset.assemblyHandling = '0';

      // Fallback to normal add
      form.submit();
    } finally {
      // release lock shortly after
      setTimeout(() => { form.dataset.assemblyHandling = '0'; }, 800);
    }
  }, true);
})();
